import {useTranslation} from '@/translations/i18n'
import {StyledDetailsInformationWarningsBannerBadge, StyledDetailsInformationWarningsBannerWrapper} from './style'
import {AlertCircleIcon, ClockRewindIcon} from '@/components/ui/icon/Icon'

export const DetailsInformationWarningsBanner = ({
    fieldsToCompile = [],
    fieldsToUpdate = []
}: {
    fieldsToCompile?: string[]
    fieldsToUpdate?: string[]
}) => {
    const {t} = useTranslation()

    return (
        <StyledDetailsInformationWarningsBannerWrapper gap={2}>
            {fieldsToCompile.length > 0 && (
                <StyledDetailsInformationWarningsBannerBadge shape="rectangle" size="lg" variant="neutral">
                    <AlertCircleIcon />
                    {t('commons:n_fields_to_compile', {count: fieldsToCompile.length})}
                </StyledDetailsInformationWarningsBannerBadge>
            )}
            {fieldsToUpdate.length > 0 && (
                <StyledDetailsInformationWarningsBannerBadge shape="rectangle" size="lg" variant="neutral">
                    <ClockRewindIcon />
                    {t('commons:n_fields_to_update', {count: fieldsToUpdate.length})}
                </StyledDetailsInformationWarningsBannerBadge>
            )}
        </StyledDetailsInformationWarningsBannerWrapper>
    )
}
